import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider } from "./context/AuthContext";
import { EntitlementsProvider } from "./context/EntitlementsContext";
import "./App.css";
import Login from "./pages/account/Login";
import Register from "./pages/account/Register";
import VerifyEmail from "./pages/account/VerifyEmail";
import RegisterComplete from "./pages/account/RegistrationComplete";
import Dashboard from "./pages/account/Dashboard";
import OrganizationSelectorPage from "./pages/platform/organizations/OrganizationSelectorPage";
import ForgetPassword from "./pages/account/ForgetPassword";
import ResetPassword from "./pages/account/ResetPassword";
import AcceptInvitation from "./pages/account/AcceptInvitation";
import Home from "./pages/home/Home";
import About from "./pages/about/About";
import Pricing from "./pages/pricing/Pricing";
import MarketingLayout from "./components/marketing/MarketingLayout";
import MFA from "./pages/mfa/MFA";
import RestaurantMenuPage from "./pages/RestaurantMenus";
import PublicSiteLayout from "./pages/public/PublicSiteLayout";
import PublicHome from "./pages/public/PublicHome";
import PublicServicesPage from "./pages/public/PublicServicesPage";
import PublicGallery from "./pages/public/PublicGallery";
import PublicContactPage from "./pages/public/PublicContactPage";
import PublicAboutPage from "./pages/public/PublicAboutPage";
import PublicSubPage from "./pages/public/PublicSubPage";
import MessagingLayout from "./pages/messaging/MessagingLayout";
import MessagingWorkspacePage from "./pages/messaging/MessagingWorkspacePage";
import CampaignListPage from "./pages/messaging/campaigns/CampaignListPage";
import CampaignCreatePage from "./pages/messaging/campaigns/CampaignCreatePage";
import CampaignDetailPage from "./pages/messaging/campaigns/CampaignDetailPage";
import TemplatesPage from "./pages/messaging/templates/TemplatesPage";
import MessageLogsPage from "./pages/messaging/logs/MessageLogsPage";
import MessagingRulesPage from "./pages/messaging/MessagingRulesPage";
import OrganizationSubscriptionPage from "./pages/platform/organizations/OrganizationSubscriptionPage";

function App() {
  return (
    <Router>
      <AuthProvider>
        <EntitlementsProvider>
          <Routes>
            <Route element={<MarketingLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/pricing" element={<Pricing />} />
            </Route>
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/register-complete" element={<RegisterComplete />} />
            <Route path="/dashboard" element={<Dashboard />} />
            <Route
              path="/dashboard/org-select"
              element={<OrganizationSelectorPage />}
            />
            <Route
              path="/organizations/:organizationId/subscription"
              element={<OrganizationSubscriptionPage />}
            />
            <Route path="/messaging" element={<MessagingLayout />}>
          <Route index element={<MessagingWorkspacePage />} />
          <Route path="campaigns" element={<CampaignListPage />} />
          <Route path="campaigns/new" element={<CampaignCreatePage />} />
          <Route path="campaigns/:id" element={<CampaignDetailPage />} />
          <Route path="templates" element={<TemplatesPage />} />
          <Route path="logs" element={<MessageLogsPage />} />
          <Route path="rules" element={<MessagingRulesPage />} />
        </Route>
        <Route path="/forget-password" element={<ForgetPassword />} />
        <Route path="/reset-password" element={<ResetPassword />} />
        <Route path="/invite" element={<AcceptInvitation />} />
        <Route path="/mfa" element={<MFA />} />
        <Route
  path="/restaurant/:id"
  element={<RestaurantMenuPage />}
/>
        <Route path="/:slug" element={<PublicSiteLayout />}>
          <Route index element={<PublicHome />} />
          <Route path="services" element={<PublicServicesPage />} />
          <Route
            path="members"
            element={
              <PublicSubPage
                title="Our Members"
                description="Meet the members of our team."
              />
            }
          />
          <Route path="gallery" element={<PublicGallery />} />
          <Route path="about-us" element={<PublicAboutPage />} />
          <Route path="contact" element={<PublicContactPage />} />
        </Route>
        {/* Unknown paths (including stale /api/... links) land on the company webpage. */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
      </EntitlementsProvider>
      </AuthProvider>
    </Router>
  );
}

export default App;
